"use client";

import { create } from "zustand";
import { devtools } from "zustand/middleware";

import type { UserProfileDto } from "@unreserved/sdk";

interface AuthStoreState {
    user: UserProfileDto | null;
    isAuthenticated: boolean;
}

interface AuthStoreActions {
    setUser: (user: UserProfileDto) => void;
    clearUser: () => void;
}

export type AuthStore = AuthStoreState & AuthStoreActions;

const initialState: AuthStoreState = {
    user: null,
    isAuthenticated: false,
};

export const useAuthStore = create<AuthStore>()(
    devtools(
        (set) => ({
            ...initialState,

            setUser: (user: UserProfileDto) => {
                set({
                    user,
                    isAuthenticated: true,
                });
            },

            clearUser: () => {
                set(initialState);
            },
        }),
        {
            name: "admin-auth-store",
            enabled: process.env.NODE_ENV === "development",
        },
    ),
);

